//this breakpoint value is use in entire application for Deskhtop and phone brakpoint
export const breakpoint = "1240px";
